var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhitecheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7074 0.292787C13.8949 0.480314 14.0002 0.734622 14.0002 0.999786C14.0002 1.26495 13.8949 1.51926 13.7074 1.70679L5.70741 9.70679C5.51988 9.89426 5.26557 9.99957 5.00041 9.99957C4.73524 9.99957 4.48094 9.89426 4.29341 9.70679L0.293407 5.70679C0.111249 5.51818 0.0104547 5.26558 0.0127331 5.00339C0.0150115 4.74119 0.12018 4.49038 0.305589 4.30497C0.490997 4.11956 0.741809 4.01439 1.00401 4.01211C1.2662 4.00983 1.5188 4.11063 1.70741 4.29279L5.00041 7.58579L12.2934 0.292787C12.4809 0.105316 12.7352 0 13.0004 0C13.2656 0 13.5199 0.105316 13.7074 0.292787Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhitecheck);
export default __webpack_public_path__ + "static/media/whitecheck.f0aa51edcf18ba171b2df6586fa7b13c.svg";
export { ForwardRef as ReactComponent };